import React from "react";
import { Row, Col, Image, Table, Spin, Popconfirm, Button, message, Pagination, Radio } from "antd";

import './index.sass';
import GroupGoods from "./com/groupGoods";
import qs from "../../../utils/qs";
import api from "../../../utils/api";

export default class GroupsDetail extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            details: null,
            dataSource: [],
            shop_goods: [],
            gb_batch_id: null,
            page: 1,
            total: 0,
            selectedRowKeys: [],
            seePro: {
                show: false
            }
        }
    }


    componentDidMount() {
        this.getGbInfo()
    }

    getGbInfo = async () => {//获取团购详情
        let gb_id = qs.hrefParam('id');

        let param = {
            gb_id
        }

        let res = await api('gb-stat', param);

        if (res.code === 200) {
            res.data.distanceNow = qs.distanceNow(res.data.settings.end_time)
            res.data.distanceNow_font = qs.distanceNow(res.data.publish_time, 'start')


            let pro_img = []

            let { details } = res.data;
            if (details && details instanceof Array) {
                for (let i in details) {
                    if (details[i]['type'] === 'bigImage') {
                        pro_img.push(details[i]['value'])
                    }
                    if (details[i]['type'] === 'smallImage') {
                        pro_img = pro_img.concat(details[i]['value'])
                    }
                }
            }

            this.setState({
                details: { ...res.data, pro_img },
                dataSource: res.data.settings.batches,
                gb_batch_id: res.data.settings.batches[0]['id']
            })

            this.get_gb_contract_products();
        }

        console.log(res,)
    }


    pasueGb = async (ctx, boolean) => {//暂停/开启团购

        let { details } = this.state

        let param = {
            gb_id: details.id,
            gb_batch_ids: [ctx.id]
        }

        let res = null

        res = boolean ? await api('pause-gb', param) : await api('resume-gb', param);

        if (res.code === 200) {
            this.getGbInfo();
            message.success('修改成功！')
        }

        console.log(res);

    }


    get_gb_contract_products = async (batch_id) => {//获取团购、合约商品列表

        //console.log(record,'get_gb_contract_products')

        let { details, dataSource } = this.state;

        let referable = details.referable;//1:合约 0 团购

        if (!batch_id) { batch_id = dataSource[0]['id'] }


        let res = {}

        let param = {
            gb_id: details.id,
            batch_id,
            gb_batch_id: batch_id
        }

        if (referable) {
            res = await api('contract-products', param)
        } else {
            res = await api('gb-products', { ...param, show_unselected: true })
        }

        if (res.code === 200) {

            this.setState({
                shop_goods: res.data
            })
        }


    }

    onSelectedRowKeysChange = (data) => {
        console.log(data, 'onSelectedRowKeysChange')
    }


    render() {

        let { details, dataSource, shop_goods, gb_batch_id, page, total, selectedRowKeys, seePro } = this.state;
        console.log(gb_batch_id, 'D4C?ED*PH-HNBSEGPXU5C9W3A@D@XS')

        const columns = [
            {
                title: '到货时间',
                dataIndex: 'arrival_date',
                key: 'arrival_date',
            },
            {
                title: '截单时间',
                dataIndex: 'end_time',
                key: 'end_time',
            },
            {
                title: '参团数',
                width: 100,
                render: (ctx) => {
                    return (
                        <p>
                            {ctx.contract_stat ? ctx.contract_stat.order_count : 0}
                        </p>
                    )
                }
            },
            {
                title: '销售额',
                render: (ctx) => {
                    return (
                        <p>
                            ￥{ctx.contract_stat ? ctx.contract_stat.sales_amount : 0}
                        </p>
                    )
                }
            },
            {
                title: '佣金',
                render: (ctx) => {
                    return (
                        <p>
                            ￥{ctx.contract_stat ? ctx.contract_stat.commission_amount : 0}
                        </p>
                    )
                }
            },
            {
                title: '状态',
                render: (ctx) => {
                    return (
                        <p>
                            {qs.groupStatus(ctx.status)}
                        </p>
                    )
                }
            },
            {
                title: '操作',
                render: (ctx) => {

                    return (
                        <div className='flex center'>{
                            !ctx.pause ? (<Popconfirm
                                title="确定暂停该团购？"
                                okText="确定"
                                cancelText="取消"
                                onConfirm={() => { this.pasueGb(ctx, true) }}
                            >

                                <Button size='small' danger>暂停</Button>
                            </Popconfirm>) : (<Popconfirm
                                title="确定开启该团购？"
                                okText="确定"
                                cancelText="取消"
                                onConfirm={() => { this.pasueGb(ctx, false) }}
                            >

                                <Button size='small' type="primary">开启</Button>
                            </Popconfirm>)}

                            <Button className='mgl10' size='small' type='link'>查看/修改 商品</Button>
                        </div>
                    )
                }
            },
        ];



        const rowSelection = {
            selectedRowKeys,
            type: 'radio',
            onChange: this.onSelectedRowKeysChange
        };

        console.log(shop_goods, 'shop_goodsshop_goods')
        return (
            <>
                {details ? (<div className='groupsDetail'>

                    <div className='flex detailTop pd10'>
                        <Row className='widthP100  alignCenter'>
                            <Col span='16' className='flex'>
                                <div className='detailTxt widthP50'>
                                    <p className='title'>{details.name}</p>

                                    <p className='font12 '><span>用户自提</span>  <span>{Math.abs(details.distanceNow_font.d)}天 {Math.abs(details.distanceNow_font.h)} 小时前发布，{details.distanceNow.d}天{details.distanceNow.h}小时{details.distanceNow.m}分钟后结束</span></p>
                                    <div className='pics flex'>


                                        {
                                            details.pro_img.map(item => {
                                                return <div className='mgr10'><Image src={item} width={80} height={80} /></div>
                                            })
                                        }

                                    </div>
                                </div>

                                <div className='detailTxt widthP50 pdl60 leftLine'>
                                    <p>截单时间：到货日前天，</p>
                                    <p>优惠活动：...</p>
                                    {/* <p>返佣比例：%</p> */}
                                    <p>所属供应商： {details.provider ? details.provider.name : ''} </p>
                                </div>
                            </Col>
                            <Col span='8'>
                                {
                                    details.contract_stat ? (<div className='user_right'>

                                        <ul className='flex census'>
                                            <li>
                                                <label>总参团人数</label>
                                                <p>{details.contract_stat ? details.contract_stat.order_count : 0}</p>
                                            </li>
                                            <li>
                                                <label>总销售额</label>
                                                <p>￥{details.contract_stat.sales_amount}</p>
                                            </li>
                                            <li>
                                                <label>总佣金</label>
                                                <p>￥{details.contract_stat.commission_amount}</p>
                                            </li>
                                        </ul>

                                    </div>) : null
                                }
                                <div className='detailNum'>

                                </div>
                            </Col>
                        </Row>

                    </div>


                    <div className='detailBot mgtb20 '>
                        <Row style={{ justifyContent: 'space-between' }}>
                            <Col span='18'>
                                <div className='tableBox pd20'>
                                    <Table
                                        dataSource={dataSource}
                                        columns={columns}
                                        pagination={false}
                                        onRow={(record) => ({
                                            onClick: () => {
                                                // console.log(record)
                                                this.setState({
                                                    seePro: {
                                                        show: true,
                                                        id: record.id,
                                                        gb_batch_id: record.id
                                                    },
                                                    gb_batch_id: record.id

                                                })

                                                this.get_gb_contract_products(record.id, record);
                                            }
                                        })}
                                        scroll={
                                            {
                                                scrollToFirstRowOnChange: false,
                                                x: false
                                            }
                                        } />


                                    <div className='page_style'>
                                        <Pagination
                                            page_size={15}
                                            hideOnSinglePage={true}
                                            onChange={(e) => { this.getProducts(e) }}
                                            defaultCurrent={1} showSizeChanger={false}
                                            current={page}
                                            total={total} />
                                    </div>
                                </div>


                            </Col>
                            <Col span='6'>
                                <GroupGoods gb_batch_id={gb_batch_id} shop_goods={shop_goods} referable={details.referable} />

                            </Col>
                        </Row>
                    </div>
                </div>) : (<Spin></Spin>)}


            </>
        )
    }
}